import { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { axiosService } from "network/axios";
import { 
  getProjectDetailRequest, 
  updateDocumentReqeust,
  requestDownloadOriginFile 
} from "store/project/reducer";
import {
  isFetchingDetails,
  selectedProjectSelector,
  unreadMessageSelector,
} from "store/project/selector";
import { userSelector } from "store/user/selector";
import { fetchUnreadMessagesCnt } from "network/helper";

export const useProjectDetail = (selectedProjectId: any | null) => {
  const dispatch = useDispatch();
  const user = useSelector(userSelector);
  const isFetching = useSelector(isFetchingDetails);
  const selectedProject = useSelector(selectedProjectSelector);
  const unreadMessages = useSelector(unreadMessageSelector);

  const [hasChanged, setHasChanged] = useState(false);
  const [isUpdatingProjectStatus, setIsUpdatingProjectStatus] = useState(false);

  useEffect(() => {
    if (selectedProjectId && dispatch) {
      dispatch(getProjectDetailRequest({ orderId: selectedProjectId }));
    }
  }, [dispatch, selectedProjectId]);

  const unreadMessageCnt = useMemo(() => {
    if (selectedProjectId && unreadMessages) {
      return fetchUnreadMessagesCnt(unreadMessages, Number(selectedProjectId));
    } else {
      return 0;
    }
  }, [unreadMessages, selectedProjectId]);

  const onUpdateDocument = (e: any) => {
    const document_id = e?.document_id;
    const document_status_id = e?.document_status_id;
    const manager_id = e?.managers?.length > 0 ? e?.managers[0].user_id : null;
    const target_lang = e?.target_lang;
    
    const payload: any = {
      order_id: selectedProjectId,
      document_id,
      document_status_id,
      new_files: e?.new_files || null,
      manager_id,
      target_lang,
      user_id: user.user_id,
      is_admin: true
    };
    
    if (e?.translators) {
      payload.translator_id = e.translators.map(({user_id}: any) => user_id) || [];
    }
    
    setHasChanged(true);
    dispatch(updateDocumentReqeust(payload));
  };

  const onDownloadFiles = (type: string) => {
    dispatch(
      requestDownloadOriginFile({
        order_id: selectedProjectId,
        user_role: "admin",
        type: type,
        file_name: `${selectedProject.order.order_name}-${type}-files.zip`,
      })
    );
  };

  const onClickUpdateDocumentsStatus = async (allDocumentStatus: any) => {
    setIsUpdatingProjectStatus(true);
    try {
      const admin = user?.user_id;
      await axiosService.put(
        `/documents/all/${allDocumentStatus.id}/${selectedProjectId}/${admin}`
      );
      dispatch(getProjectDetailRequest({ orderId: selectedProjectId }));
    } catch (e) {
      console.log(e);
    } finally {
      setIsUpdatingProjectStatus(false);
    }
  };

  return {
    selectedProject,
    isFetching,
    hasChanged,
    unreadMessageCnt,
    isUpdatingProjectStatus,
    onUpdateDocument,
    onDownloadFiles,
    onClickUpdateDocumentsStatus,
    setHasChanged
  };
};
